export default __webpack_public_path__ + "../staticImages/sprite-forecast-hermes-2x.png";